import { createContext } from 'react'

import { SupplyChainContextType } from './types'

export const SupplyChainContext = createContext<SupplyChainContextType>(
  {} as SupplyChainContextType,
)
